import { Component, ViewChild} from '@angular/core';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { ExcelService } from './excel.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public settings: Settings;
  constructor(
    public appSettings:AppSettings,
    private excelService:ExcelService
  ){
      this.settings = this.appSettings.settings;
  } 
/*
  ngOnInit() { }


  data: any = [{
    eid: 'e101',
    ename: 'ravi',
    esal: 1000
    },{
    eid: 'e102',
    ename: 'ram',
    esal: 2000
    },{
    eid: 'e103',
    ename: 'rajesh',
    esal: 3000
    }];

    exportAsXLSX():void {
       this.excelService.exportAsExcelFile(this.data, 'sample');
    }
*/
}